import { handleApiError, handleApiResponse } from "@/methods/api";
import ApiVerified from "@/services/apiVerified";
import { ApiResponse } from "@/types/global";
import {
  TeacherActionableCards,
  TeacherBatchInfo,
  TeacherPublishedActivity,
} from "@/types/teacher";

export default class TeacherApi extends ApiVerified {
  async getBatchInfoForTeacher(
    teacherId: number,
    onlyActive: boolean = true,
  ): Promise<ApiResponse> {
    try {
      const response = await this.axiosInstance.get<Array<TeacherBatchInfo>>(
        `teacher/get-batch-info-for-teacher`,
        { params: { teacherId: teacherId, onlyActive: onlyActive } },
      );
      return handleApiResponse(response);
    } catch (error) {
      return handleApiError(error);
    }
  }

  async getPublishedActivityListForTeacher(teacherId: number): Promise<ApiResponse> {
    try {
      const response = await this.axiosInstance.get<Array<TeacherPublishedActivity>>(
        `teacher/get-published-activity-list-for-teacher`,
        { params: { teacherId: teacherId } },
      );
      return handleApiResponse(response);
    } catch (error) {
      return handleApiError(error);
    }
  }

  async getActionableCardsForTeacher(teacherId: number): Promise<ApiResponse> {
    try {
      const response = await this.axiosInstance.get<TeacherActionableCards>(
        `teacher/get-actionable-cards-for-teacher`,
        { params: { teacherId: teacherId } },
      );
      return handleApiResponse(response);
    } catch (error) {
      return handleApiError(error);
    }
  }
}
